module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _vm._v("•  CONTENTS  •")]), _vm._v(" "), _c('p', {
    staticClass: "indentnumber"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/frontmatter001"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "indentnumber"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter001"
    }
  }, [_c('em', [_vm._v("One")]), _vm._v(": Pandora’s Box")])]), _vm._v(" "), _c('p', {
    staticClass: "indentnumber"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter002"
    }
  }, [_c('em', [_vm._v("Two")]), _vm._v(": Stripped")])]), _vm._v(" "), _c('p', {
    staticClass: "indentnumber"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter003"
    }
  }, [_c('em', [_vm._v("Three")]), _vm._v(": Corseted")])]), _vm._v(" "), _c('p', {
    staticClass: "indentnumber"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Four")]), _vm._v(": Ride Like a Man")])]), _vm._v(" "), _c('p', {
    staticClass: "indentnumber"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Five")]), _vm._v(": The Pouf Ascendant")])]), _vm._v(" "), _c('p', {
    staticClass: "indentnumber"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Six")]), _vm._v(": The Simple Life")])]), _vm._v(" "), _c('p', {
    staticClass: "indentnumber"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Seven")]), _vm._v(": Galled")])]), _vm._v(" "), _c('p', {
    staticClass: "indentnumber"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Eight")]), _vm._v(": Revolutionary Redress")])]), _vm._v(" "), _c('p', {
    staticClass: "indentnumber"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Nine")]), _vm._v(": True Colors")])]), _vm._v(" "), _c('p', {
    staticClass: "indentnumber"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Ten")]), _vm._v(": Black")])]), _vm._v(" "), _c('p', {
    staticClass: "indentnumber"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Eleven")]), _vm._v(": White")])]), _vm._v(" "), _c('p', {
    staticClass: "indentnumber"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword: Fashion Victim")])]), _vm._v(" "), _c('p', {
    staticClass: "indentnumber"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "indentnumber"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selected Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "indentnumber"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "indentnumber"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Illustration Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "indentnumber"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/backmatter006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ac427ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 78
// module chunks = 0